import { render } from "./room_quantity.vue?vue&type=template&id=6bfba510"
import script from "./room_quantity.vue?vue&type=script&lang=js"
export * from "./room_quantity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__